<template>
    <div>
        <slot />
    </div>
</template>

<script>
import Swal from "sweetalert2";
import Echo from "laravel-echo";
export default {
    components: {
        Echo,
    },
    props: {
        title: String,
    },
    data() {
        return {
            isProfileMenuShow: false,
            isNotificationShow: false,
            isMenuExpanded: false,
            notice_count: "",
            notices: [],
        };
    },
    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = `${title} - Synthesis`;
            },
        },
    },
};
</script>
